import { render, staticRenderFns } from "./shouquanConent.vue?vue&type=template&id=8431c89e&scoped=true"
import script from "./shouquanConent.vue?vue&type=script&lang=js"
export * from "./shouquanConent.vue?vue&type=script&lang=js"
import style0 from "./shouquanConent.vue?vue&type=style&index=0&id=8431c89e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8431c89e",
  null
  
)

export default component.exports